function copyToClipboard(element) {
  var $temp = $("<input>");
  var oldValue = $(element).html();
  
  $("body").append($temp);
  $temp.val($(element).html()).select();
  document.execCommand("copy");
  $(element).html("COPIADO");
  setTimeout(function(){ $(element).html(oldValue); }, 300);
  $temp.remove();

} 

$('cupom').click(function(){
  copyToClipboard(this);
});

(function() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    const attributes = {};

    utmParams.forEach(param => {
        const value = params.get(param);
        if (value) {
            attributes[`${param}`] = value;
        }
    });

    if (Object.keys(attributes).length > 0) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes })
        });
    }
})();

if (window.location.pathname === '/products/sache-sabonete-intimo-hidratante-feminino-dermosex-4-ml' || window.location.pathname === '/products/brinde-sache-creme-corporal-super-hidratante-dermosex-4g') {
    window.location.replace('/');
}

